<template>
  <page-header-wrapper @back="back">
    <template v-slot:breadcrumb>
      {{ formTitle }}
    </template>
    <template v-slot:title>
      {{ formTitle }}
    </template>
    <div class="bg-white padding-lr" ref="container">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol"   labelAlign="left" :model="form" :rules="rules">
        <a-collapse v-model="activeKey">
          <a-collapse-panel key="1" :header="$t('基础信息')" class="goods-collapse">
            <a-row v-if="formType===2">
              <a-col :span="12">
                <a-form-model-item :label="$t('商品编号')">
                  <a-input disabled v-model="form.id" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }" :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="form.goodsName" :maxLength="128" :placeholder="$t('请输入')+$t('商品名称')" >
                    <locale-field-button
                      slot="suffix"
                      class="ant-input-suffix-button"
                      v-model="form.localeFieldMap['goodsName']"
                      input-type="input"
                      table-name="goods_goods"
                      table-field="goodsName"
                      :field-value="form.goodsName"
                    />
                  </a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="10">
                <a-form-model-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :label="$t('商品分类')" prop="categoryIds">
                  <template>
                    <a-tree-select
                      v-model="categorySelected"
                      style="width: 100%"
                      :tree-data="categoryList"
                      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                      :placeholder="$t('请输入')+$t('商品分类')"
                      :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                      multiple
                      show-search
                      :tree-node-filter-prop="'title'"
                      allowClear
                      tree-default-expand-all
                      @change="onCategoryChange" />
                  </template>
                </a-form-model-item>
              </a-col>
              <a-col :span="2" v-has-permi="['goods:category:add']">
                <a-button type="primary" @click="openCategorySelect" style="float: right; text-align: left; margin-top: 2px">
                  {{$t('新增分类')}}
                </a-button>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('品牌')" prop="brandId">
                  <a-select style="width: 100%" v-model="form.brandId" placeholder="请选择品牌">
                    <a-select-option v-for="(item, index) in brandList" :value="item.id" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品关键词')" prop="keyword">
                  <a-input v-model="form.keyword" :maxLength="128" :placeholder="$t('使用英文状态下的逗号拼接')">
                  </a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="goodsType">
                     <span slot="label">
                      <a-tooltip>
                        {{$t('商品类型')}}<template slot="title">Please set the second kill product to a single specification</template>
                      </a-tooltip>
                    </span>
                  <a-radio-group v-model="form.goodsType" button-style="solid">
                    <a-radio-button v-for="(item, index) in customDict.GoodsTypeEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('选择运费模板')" prop="freightTemplateId">
                  <a-button type="dashed" style="text-align: left; width: 100%" @click="openFreightTemplateSelect()" danger>
                    <span style="color: dodgerblue">{{this.getFreightName()}}</span>
                  </a-button>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品视频')" prop="video">
                  <oss-upload-single v-model="form.video" prefix="goods" type="video" :max-size="1024"/>
                  <span>{{$t('注意视频') }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item :label="this.$t('商品主图')" prop="picture">
                  <oss-upload-single v-model="form.picture" prefix="goods" type="img" />
                  <span>{{this.$t('推荐尺寸')}} 375 x 375</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品轮播图')" prop="imgList">
                  <oss-upload-multi :is-array-data="true" :max-count="10" v-model="form.imgList" prefix="goods" type="img" />
                  <span>{{this.$t('推荐尺寸')}} 375 x 375</span>
                </a-form-model-item>
              </a-col>
            </a-row>


          </a-collapse-panel>
          <a-collapse-panel key="2" :header="$t('标签信息')"  class="goods-collapse">
            <a-row>
              <a-col :span="8">
                <a-form-model-item :label-col="{span: 6}" :wrapper-col="{span: 18}" :label="$t('标签')" prop="labelList">
                  <a-select mode="multiple"  :placeholder="$t('请选择')+$t('标签')" style="width: 100%" v-model="form.labelList" allowClear>
                    <a-select-option v-for="(item, index) in labelList" :value="item.id+''" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="2" v-has-permi="['goods:label:add']">
                <a-button type="primary"  @click="openLabelSelect" style="float: right; text-align: left; margin-top: 2px" >
                 {{$t('新增标签')}}
                </a-button>
              </a-col>
              <a-col :span="2">
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item v-if="form.goodsType!==30" class="margin-bottom-10" :label="$t('是否推荐')" prop="isRecommend">
                  <a-radio-group v-model="form.isRecommend"  button-style="solid">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item v-if="form.goodsType!==30" class="margin-bottom-10" :label="$t('是否新品')" prop="isNew">
                  <a-radio-group v-model="form.isNew" button-style="solid">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>

            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item class="margin-bottom-10" :label="$t('是否展示')" prop="isShowApp">
                  <a-radio-group v-model="form.isShowApp" button-style="solid">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item class="margin-bottom-10" :label="$t('商品状态')" prop="status">
                  <a-radio-group v-model="form.status" button-style="solid">
                    <a-radio-button v-for="(item, index) in this.customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>

              <a-col :span="12">
                <a-form-model-item  prop="refundTime">
                  <span slot="label" >
                    <a-tooltip>{{$t('退款申请时间')}}<template slot="title">{{$t('退款申请说明')}}</template></a-tooltip>
                  </span>
                  <a-input-number v-model="form.refundTime" style="width: 45%" :maxLength="9" :min="0" :max="999999"
                                  :placeholder="$t('请输入')+$t('退款申请时间')"  addon-after="分钟"/>
                  <span class="ant-input-suffix">分钟</span>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="5" :header="$t('营销设置')" class="goods-collapse">
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('联盟佣金')" prop="allianceCommissionType">
                  <a-radio-group v-model="form.allianceCommissionType" default-value="1">
                    <a-radio-button :value="1">{{$t('固定金额')}}</a-radio-button>
                    <a-radio-button :value="2">{{$t('百分比')}}</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="allianceCommission">
                  <a-input-number v-model="form.allianceCommission" style="width: 90%;" :min="0" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="3" :header="$t('规格信息')"  class="goods-collapse">
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品售价')" prop="marketPrice">
                  <a-input-number v-model="form.marketPrice" style="width: 100%" :min="0" :max="999999999" :step="0.01" :precision="2"  @change="limitMarketPrice()"
                                  :placeholder="$t('请输入')+$t('商品售价')"/><span class="ant-input-suffix">¥</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('成本价')" prop="costPrice">
                  <a-input-number v-model="form.costPrice" style="width: 100%" :min="0" :max="999999999" :step="0.01" :precision="2"
                                  :placeholder="$t('请输入')+$t('成本价')"/><span class="ant-input-suffix">¥</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('是否展示销量')" prop="isShowSalesNum">
                  <a-radio-group button-style="solid" v-model="form.isShowSalesNum">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('虚拟销量')" prop="virtualSalesNum">
                  <a-input-number v-model="form.virtualSalesNum" style="width: 100%" :min="0" :max="999999999"
                                  :placeholder="$t('请输入')+$t('虚拟销量')"/>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col span="2" >
                <a-button v-if="form.specList.length < 4" type="primary" @click="addSpec(1)"
                          class="margin-bottom">
                  <a-icon type="plus"/>
                  {{$t('添加规格')}}
                </a-button>
              </a-col>
              <!--              <a-col span="2" v-if="specDisable && form.isMultipleSpec">
                              <a-button  v-if="form.specList.length < 4" :disabled="!specDisable" type="primary" style="width: 100%" @click="editSpec()"
                                        class="margin-bottom">
                                <a-icon type="edit"/>
                                {{$t('修改规格')}}
                              </a-button>
                            </a-col>-->
              <a-col :span="20" >
              </a-col>
            </a-row>
            <div >
              <div class="box" v-for="(item, id) in form.specList" :key="id" >
                <a-row>
                  <a-popconfirm  title="Are you sure you want to delete this specification?" ok-text="sure" cancel-text="cancel" @confirm="delSpec(id)">
                    <a-icon v-if="formType===1" type="close-circle" class="delSpec"/>
                  </a-popconfirm>
                  <a-col :span="12">
                    <a-form-model-item layout="inline" :label="$t('规格名称')" :prop="`specList.${id}.specName`" :rules='rules.specName'>
                      <a-input v-model="item.specName" :placeholder="$t('请输入')"/>
                    </a-form-model-item>
                  </a-col>
                  <div class="margin-bottom-10" >
                    <a-button type="primary" @click='addSpecValue(item,null,[])'>
                      {{$t('添加规格值')}}
                    </a-button>
                  </div>
                 </a-row>

                <a-row>
                  <a-col :span="20" >
                    <a-table :data-source="item.specValueList.filter(e => !e.isDeleted)" :columns="specValueColumns" rowKey="id" :pagination="false"
                             bordered>
                      <div slot="specValueName" slot-scope="text, record">
                        <a-input v-model="record.specValueName" @change="specValueChange(record)" :maxLength="128" placeholder="请输入规格" @blur="validatorSpecValue(item)">
                        </a-input>
                      </div>
                      <div slot="action" slot-scope="text, record" >
                        <a-popconfirm title="确定要删除此规格值吗？" ok-text="确定" cancel-text="取消" 
                                      @confirm="delSpecValue(item,record)">
                          <a href="javascript:void(0)" style="color:red;" >删除</a>
                        </a-popconfirm>
                      </div>
                    </a-table>
                    <span style="color: red;" v-if="item.specErrorMessage">{{ item.specErrorMessage }}</span>
                  </a-col>
                </a-row>
              </div>
              <!--    sku列表        -->
              <div>
<!--                <a-row v-if="this.formType===1">
                  <a-col :span="20" :offset="2">
                    <a-button class='margin-tb' type="primary" @click="generateSkus" :disabled="this.formType===2">{{$t('生成sku')}}</a-button>
                  </a-col>
                </a-row>-->
                <!--                <a-row v-if="this.formType===2 && this.form.specList.filter(e=>e.isNew).length>0">
                                  <a-col :span="20" :offset="2">
                                    <a-button class='margin-tb' type="primary" @click="alignSpecSkus" >规格对齐</a-button>
                                  </a-col>
                                </a-row>-->
                <a-row>
                  <a-col :span="22" :offset="2">
                    <a-table :loading="skuLoading" :data-source="form.skuList.filter(e => !e.isDeleted)" :columns="skuColumns" rowKey="id" :pagination="false" bordered>
                      <div slot="skuPriceTitle">
                        <a-space size="small">
                          <span >{{$t('价格')}}</span>
                          <a-button type="link" size="small" @click="batchEditPrice">
                            <a-icon type="edit" />
                          </a-button>
                        </a-space>
                      </div>
                      <div slot="skuSeckillPriceTitle">
                        <a-space size="small">
                          <span >{{$t('秒杀价格')}}</span>
                          <a-button type="link" size="small" @click="batchEditSeckillPrice">
                            <a-icon type="edit" />
                          </a-button>
                        </a-space>
                      </div>
                      <div slot="skuPrice" slot-scope="text, record">
                        <a-input-number v-model="record.price"  style="width: 100%" :min="0" :max="999999999" :step="0.01" :precision="2" :placeholder="$t('请输入')+$t('商品价格')"  @blur.native.capture="validatorSku" />
                      </div>
                      <div slot="skuStockTitle">
                        {{$t('库存')}}
                        <a-tooltip>
                          <template slot="title">
                            <p>When modifying the inventory of an existing SKU, the inventory does not update. There is a dedicated place for inventory modification to cancel.</p>
                          </template>
                          <a-icon type="question-circle" />
                        </a-tooltip>
                      </div>
<!--                      <div slot="importSpec" slot-scope="text, record">-->
<!--                        <a @click="openSpecSkuSelect(record)" v-if="form.goodsBatchId" style="text-decoration: underline; text-underline-offset: 4px;">导入商品版本</a>-->
<!--                        <span>  [{{record.archiveSkuList.length}}]</span>-->
<!--                      </div>-->
<!--                      <div slot="skuMemberPrice" slot-scope="text, record">-->
<!--                        <a-input v-model="record.memberPrice" :placeholder="$t('请输入')+$t('会员价格')"/>-->
<!--                      </div>-->
<!--                      <div slot="skuSeckillPrice" slot-scope="text, record">-->
<!--                        <a-input v-model="record.seckillPrice" :placeholder="$t('请输入')+$t('秒杀价格')"/>-->
<!--                      </div>-->
                      <div slot="skuMaxBuyNum" slot-scope="text, record">
                        <a-input-number v-model="record.maxBuyNum" style="width: 100%" :min="0"/>
                      </div>
                      <div slot="skuFreight" slot-scope="text, record">
                        <a @click="openSkuFreightTemplateSelect(record.id,record.freightTemplateId)" style="text-decoration: underline; text-underline-offset: 4px;">
                          <span v-if="record.freightTemplateId"> {{record.freightTemplateName}}</span>
                          <span v-else>选择运费</span>
                        </a>
                      </div>
<!--                      <div slot="skuActivityPrice" slot-scope="text, record">
                        <a-input-number v-model="record.activityPrice"  style="width: 100%" :min="0" :max="999999999" :step="0.01" :precision="2" :placeholder="$t('请输入')+$t('活动价格')"  @blur.native.capture="validatorSku" />
                      </div>-->
                      <div slot="skuSeckillPrice" slot-scope="text, record">
                        <a-input-number v-model="record.seckillPrice"  style="width: 100%" :min="0" :max="999999999" :step="0.01" :precision="2" :placeholder="$t('请输入')+$t('秒杀价格')"  @blur.native.capture="validatorSku" />
                      </div>
<!--                      <div slot="skuGroupPrice" slot-scope="text, record">-->
<!--                        <a-input v-model="record.groupPrice" :placeholder="$t('请输入')+$t('团购价格')"/>-->
<!--                      </div>-->
                      <div slot="skuCode" slot-scope="text, record">
                        <a-input v-model="record.skuCode"  :placeholder="$t('请输入')+$t('SKU编码')"  @blur.native.capture="validatorSku" />
                      </div>
                      <div slot="skuWeight" slot-scope="text, record">
                        <a-input-number v-model="record.weight" :min="0" :placeholder="$t('请输入')+$t('商品重量')"  @blur.native.capture="validatorSku" />
                      </div>
                      <div slot="skuStock" slot-scope="text, record">
                        <a-input-number v-model="record.stock" :min="0"  :placeholder="$t('请输入')+$t('商品库存')"  @blur.native.capture="validatorSku" />
                      </div>
                      <template slot="skuPicture" style="width: 50px;height: 50px" slot-scope="text, record">
                        <oss-upload-single :height="50" :width="50"  v-model="record.picture" prefix="goods" type="img"/>
                      </template>
                      <div slot="skuAction" slot-scope="text, record">
                        <a-popconfirm 
                          :title="$t('确定要删除该SKU吗？')"
                          ok-text="确定"
                          cancel-text="取消"
                          @confirm="delSku(record)"
                        >
                          <a href="javascript:void(0)" style="color:red;">{{ $t('删除') }}</a>
                        </a-popconfirm>
                      </div>
                    </a-table>
                    <span style="color: red;" v-if="skuErrorMessage">{{ skuErrorMessage }}</span>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-collapse-panel>
          <a-collapse-panel key="4" :header="$t('商品详情')"   class="goods-collapse">
            <a-row style="height: 30px">
              <a-col></a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}"  :label="$t('商品详情')" prop="description">
                  <editor v-model="form.description" :placeholder="$t('请输入')+$t('商品详情')"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <a-divider></a-divider>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              {{ $t('保存') }}
            </a-button>
            <a-button type="dashed" @click="cancel">
              {{ $t('取消') }}
            </a-button>
          </a-space>
        </div>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl"/>
        </a-modal>
        <a-modal :visible="previewVideoVisible"  :footer="null"  @close="previewVideoCancel" @cancel="previewVideoCancel">
          <video ref="previewVideo" style="width: 100%" controls>
            <source :src="previewUrl" type="video/mp4" />
          </video>
        </a-modal>
      </a-form-model>

      <radio-freight-select-form ref="RadioFreightSelectForm" @freightSelect="indexFreightTemplateSelect"></radio-freight-select-form>
      <category-create-form ref="CategoryCreateForm" @ok="getCategoryList"></category-create-form>
      <brand-create-form ref="BrandCreateForm" @ok="getBrandList"></brand-create-form>
      <label-create-form ref="LabelCreateForm" @ok="getLabelList"></label-create-form>
    </div>
  </page-header-wrapper>

</template>

<script>
import {allBrand} from '@/api/goods/brand'
import {addGoods, getGoods, updateGoods} from '@/api/goods/goods'
import {listGoodsBatch} from '@/api/goods/goodsBatch'
import {listCategory} from "@/api/goods/category";
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from '@/components/Editor'
import CategoryCreateForm from "@/views/goods/category/modules/CreateForm";
import BrandCreateForm from "@/views/goods/brand/modules/CreateForm";
import LabelCreateForm from "@/views/goods/label/modules/CreateForm";
import {translation} from "@/api/tool/common";
import RadioFreightSelectForm from "@/views/shipping/shippingTemplate/modules/RadioSelectForm";
import {shippingTemplatesList} from '@/api/logistics'
import events from "@/components/MultiTab/events";
import bus from "@/utils/bus";
import {allLabel} from "@/api/goods/label";
import OssUploadMulti from '@/components/OssUploadMulti/index.vue'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    Editor,
    OssUploadMulti,
    OssUploadSingle,
    RadioFreightSelectForm,
    CustomDictTag,
    CategoryCreateForm,
    BrandCreateForm,
    LabelCreateForm
  },
  data() {
    return {
      tabIndex: 1,
      categoryList: [{id: "0", categoryName: '', children: []}],
      brandList: [],
      labelList:[],
      batchList:[],
      /*是否有规格图片*/
      isSpecPic: false,
      /*分类的回显*/
      categorySelected: [],
      labelCol: {span: 4},
      activeKey: [1, 2, 3, 4],
      wrapperCol: {span: 16},
      submitLoading: false,
      normalGoodsType: 10,
      giftGoodsType: 30,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      skuLoading: false,
      skuErrorMessage:undefined,
      errorMessage:undefined,
      batchPriceModalVisible: false,
      batchPriceValue: null,
      specValueColumns: [
        {
          title: this.$t('规格值'),
          dataIndex: 'specValueName',
          key: 'specValueName',
          scopedSlots: {customRender: 'specValueName'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'}
        }
      ],
      skuColumns: [
        {
          title: this.$t('名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        }, {
          title: this.$t('编码'),
          dataIndex: 'skuCode',
          key: 'skuCode',
          scopedSlots: {customRender: 'skuCode'}
        }, {
          dataIndex: 'price',
          width:150,
          key: 'price',
          scopedSlots: {customRender: 'skuPrice'},
          slots: { title: 'skuPriceTitle' }
        }, /*{
          title: this.$t('活动价格'),
          dataIndex: 'activityPrice',
          key: 'activityPrice',
          width:100,
          scopedSlots: {customRender: 'skuActivityPrice'}
        },*/
        {
          dataIndex: 'seckillPrice',
          key: 'seckillPrice',
          width:150,
          scopedSlots: {customRender: 'skuSeckillPrice'},
          slots: { title: 'skuSeckillPriceTitle' }
        },
        {
          dataIndex: 'stock',
          slots: { title: 'skuStockTitle' },
          key: 'stock',
          scopedSlots: {customRender: 'skuStock'}
        }, {
          title: this.$t('重量'),
          dataIndex: 'weight',
          key: 'weight',
          scopedSlots: {customRender: 'skuWeight'}
        },         {
          title: this.$t('图片'),
          dataIndex: 'picture',
          key: 'picture',
          scopedSlots: {customRender: 'skuPicture'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'skuAction',
          width: 90,
          scopedSlots: {customRender: 'skuAction'}
        },
      ],
      /*是否发生了规格变动如果有则保存到后台时会先执行删除商品操作 后执行添加商品操作  如果没有则 直接修改*/
      isChangeSpec: false,
      // 表单参数
      form: {
        id: null,
        keyword:null,
        allianceCommissionType:null,
        allianceCommission:0,
        goodsBatchId: null,
        isChangeSpec: false,
        specList: [],
        labelList: [],
        prodAreaList: [86],
        skuList: [],
        isMultipleSpec: null,
        isAllowMerge: null,
        maxBuyNum: null,
        onSaleTime: null,
        imgList: [],
        starDetail: null,
        freightTemplateDetail: null,
        goodsCode: null,
        goodsName: null,
        goodsType: 10,
        weight: null,
        unit: null,
        unitCount:1,
        picture: null,
        video: null,
        color: null,
        refundTypeList: [1, 2],
        refundTime: 0,
        imgIdArray: null,
        categoryId: null,
        categoryIds: [],
        shopId: null,
        shopCategoryId: null,
        brandId: null,
        price: null,
        marketPrice: null,
        costPrice: 0,
        virtualSalesNum: 0,
        activityPrice: null,
        seckillPrice: null,
        memberPrice: null,
        groupPrice: null,
        freightTemplateId: null,
        stock: null,
        alarmStock: null,
        description: null,
        isRecommend: null,
        isNew: null,
        isOrderLock: false,
        isHavePoster: false,
        isShowCalendar: null,
        isShowSalesNum: false,
        isShowStock: false,
        isShowApp: true,
        isRequireRemark: false,
        sort: null,
        parameter: null,
        prodArea: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsCode: [{required: true, message: this.$t('商品编号') + this.$t('不能为空'), trigger: 'blur'}],
        goodsName: [{required: true, message: this.$t('商品名称') + this.$t('不能为空'), trigger: 'change'}],
        goodsType: [{required: true, message: this.$t('商品类型') + this.$t('不能为空'), trigger: 'blur'}],
        specName: [{required: true, message: this.$t('规格名称') + this.$t('不能为空'), trigger: 'change'}],
        specValueName: [{required: true, message: this.$t('规格值') + this.$t('不能为空'), trigger: 'change'}],
        weight: [{required: true, message: this.$t('商品重量') + this.$t('不能为空'), trigger: 'blur'}],
        picture: [{required: true, message: this.$t('商品主图') + this.$t('不能为空'), trigger: 'blur'}],
        categoryIds: [{required: true, type: 'array', min: 1, message: this.$t('商品分类') + this.$t('不能为空'), trigger: 'change'}],
        price: [{required: true, message: this.$t('商品价格') + this.$t('不能为空'), trigger: 'blur'}],
        memberPrice: [{required: true, message: this.$t('会员价格') + this.$t('不能为空'), trigger: 'blur'}],
        groupPrice: [{required: true, message: this.$t('团购价格') + this.$t('不能为空'), trigger: 'blur'}],
        activityPrice: [{required: true, message: this.$t('活动价格') + this.$t('不能为空'), trigger: 'blur'}],
        seckillPrice: [{required: true, message: this.$t('秒杀价格') + this.$t('不能为空'), trigger: 'blur'}],
        marketPrice: [{required: true, message: this.$t('商品售价') + this.$t('不能为空'), trigger: 'blur'}],
        costPrice: [{required: true, message: this.$t('成本价') + this.$t('不能为空'), trigger: 'blur'}],
        virtualSalesNum: [{required: true, message: this.$t('虚拟销量') + this.$t('不能为空'), trigger: 'blur'}],
        freightTemplateId: [{required: true, message: this.$t('运费模板') + this.$t('不能为空'), trigger: 'change'}],
        stock: [{required: true, message: this.$t('商品库存') + this.$t('不能为空'), trigger: 'blur'}],
        isRecommend: [{required: true, message: this.$t('是否推荐') + this.$t('不能为空'), trigger: 'blur'}],
        isNew: [{required: true, message: this.$t('是否新品') + this.$t('不能为空'), trigger: 'blur'}],
        isShowSalesNum: [{required: true, message: this.$t('是否展示销量') + this.$t('不能为空'), trigger: 'blur'}],
        isShowStock: [{required: true, message: this.$t('是否展示库存') + this.$t('不能为空'), trigger: 'blur'}],
        isShowApp: [{required: true, message: '是否在app上显示' + this.$t('不能为空'), trigger: 'blur'}],
        status: [{required: true, message: '商品状态' + this.$t('不能为空'), trigger: 'blur'}],
        sort: [{required: true, message: this.$t('排序') + this.$t('不能为空'), trigger: 'blur'}],
      }
    };
  },
  filters: {},
  created() {
    this.getCategoryList()
    this.getBrandList()
    this.getLabelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    'form.picture'() {
      this.pictureChange()
    },
  },
  mounted() {
    this.form.id = this.$route.query.id
    let copy = this.$route.query.copy
    if (this.form.id) {
      this.handleUpdate(this.form.id, copy)
    } else {
      this.handleAdd()
    }
  },
  methods: {
    container() {
      return this.$refs.container;
    },
    // 批量修改价格
    batchEditPrice() {
      const self = this;
      this.batchPriceValue = null;

      this.$confirm({
        title: this.$t('批量修改价格'),
        content: (
          <div style="margin-top: 16px;">
            <a-input-number
              vModel={self.batchPriceValue}
              style="width: 100%"
              min={0}
              max={999999999}
              step={0.01}
              precision={2}
              placeholder={this.$t('请输入价格')}
            />
          </div>
        ),
        onOk() {
          if (self.batchPriceValue === null || self.batchPriceValue === undefined) {
            self.$message.warning(self.$t('请输入价格'));
            return Promise.reject();
          }

          // 批量修改所有SKU的价格
          self.form.skuList.forEach(sku => {
            sku.price = self.batchPriceValue;
          });

          self.$message.success(self.$t('批量修改成功'));
        }
      });
    },
    // 批量修改价格
    batchEditSeckillPrice() {
      const self = this;
      this.batchPriceValue = null;

      this.$confirm({
        title: this.$t('批量修改价格'),
        content: (
          <div style="margin-top: 16px;">
            <a-input-number
              vModel={self.batchPriceValue}
              style="width: 100%"
              min={0}
              max={999999999}
              step={0.01}
              precision={2}
              placeholder={this.$t('请输入价格')}
            />
          </div>
        ),
        onOk() {
          if (self.batchPriceValue === null || self.batchPriceValue === undefined) {
            self.$message.warning(self.$t('请输入价格'));
            return Promise.reject();
          }

          // 批量修改所有SKU的价格
          self.form.skuList.forEach(sku => {
            sku.seckillPrice = self.batchPriceValue;
          });

          self.$message.success(self.$t('批量修改成功'));
        }
      });
    },
    back() {
      let pages = this.$store.pages;
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      // 去更新列表页的数据
      bus.$emit('updateGoodsList')
      this.$router.push({path: '/goods/goods', replace: true, query:{}  })
    },
    /*锚点*/
    getCurrentAnchor() {
      return '#components-anchor-demo-static';
    },
    changeTab(index, type) {
      if (type === 'next') {
        let isValid = false
        this.$refs.form.validate(valid => {
          isValid = valid;
        });
        if (!isValid) {
          console.log('有必填项未填');
          return
        }
        this.tabIndex = index + 1;
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    isSpecPicChange(e) {
      //其他规格就不能有图片了
      this.isSpecPic = e.target.value
    },
    generateSkus() {
      this.skuLoading = true;
      this.form.skuList = [];
      let  skuValueList = [];
      //拿到所有的sku值
      this.form.specList.forEach(spec => {
        skuValueList.push(spec.specValueList);
      });
      //递归,求笛卡尔积
      let sku = this.cartesianProduct(skuValueList);
      //把这些sku 组装一下放到skuList里
      let skuList = [];
      let index = 1;
      sku.forEach(e => {
        let name = '';
        let skuPic = this.form.picture;
        let specValueIds = '';
        e.forEach(j => {
          name += j.specValueName + "  ";
          specValueIds += j.id + ":";
        });
        specValueIds = specValueIds.substring(0, specValueIds.length - 1);
        const newData = {
          id: index,
          skuName: name,
          skuCode: null,
          price: this.form.marketPrice,
          memberPrice: this.form.marketPrice,
          groupPrice: this.form.marketPrice,
          activityPrice: this.form.marketPrice,
          seckillPrice: this.form.marketPrice,
          maxBuyNum: this.form.maxBuyNum ? this.form.maxBuyNum :0,
          freightTemplateId: this.form.freightTemplateId,
          freightTemplateName: this.form.freightTemplateDetail ? this.form.freightTemplateDetail.name : '',
          picture: skuPic,
          specValueIds: specValueIds,
          isNew :true,
          stock: 99999,
          weight: 100,
        };
        skuList.push(newData);
        index++;
      });
      this.form.skuList = skuList;
      this.skuLoading = false;
    },


    cartesianProduct(arr) {
      if (arr.length === 0) {
        return [[]];
      }
      const result = [];
      const rest = this.cartesianProduct(arr.slice(1));
      for (let i = 0; i < arr[0].length; i++) {
        for (let j = 0; j < rest.length; j++) {
          result.push([arr[0][i], ...rest[j]]);
        }
      }
      return result;
    },
    onClose() {
      this.open = false
      this.reset()
      this.back()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      this.back()
    },
    onRefundTypeChange(value) {
      console.log('refundtypevalue',value)
      console.log('refundtypevalue',this.form.refundType)

    },

    openCategorySelect () {
      this.$refs.CategoryCreateForm.handleAdd();
    },

    openBrandSelect () {
      this.$refs.BrandCreateForm.handleAdd();
    },
    openLabelSelect () {
      this.$refs.LabelCreateForm.handleAdd();
    },

    openFreightTemplateSelect () {
      this.$refs.RadioFreightSelectForm.openList(this.form.freightTemplateId);
    },
    openSkuFreightTemplateSelect (index,tmpId) {
      console.log('index',index)
      console.log('sku',this.form.skuList)
      this.$refs.RadioFreightSelectForm.openList(tmpId,index, this.form.freightTemplateDetail.type);
    },
    indexFreightTemplateSelect(record,index) {
      console.log('选择了',record,index);
      if (index) {
        //sku里的
        this.form.skuList.forEach(e=>{
          if (e.id === index) {
            e.freightTemplateId= record.id
            e.freightTemplateName = record.name
          }
        })
      } else {
        this.form.freightTemplateId = record.id;
        this.form.freightTemplateDetail = record
        this.form.skuList.forEach(e=>{
          e.freightTemplateId= record.id
          e.freightTemplateName = record.name
        })
      }
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.categorySelected= [];
      this.isChangeSpec=false;
      this.form = {
        id: null,
        goodsBatchId: null,
        isMaxBuy: false,
        isChangeSpec: false,
        specList: [],
        labelList: [],
        prodAreaList: [86],
        skuList: [],
        isMultipleSpec: false,
        isAllowMerge: true,
        freightTemplateDetail: null,
        maxBuyNum: null,
        onSaleTime: null,
        goodsCode: null,
        goodsName: null,
        goodsType: 10,
        weight: null,
        unit: null,
        unitCount:1,
        starDetail: null,
        imgList: [],
        picture: null,
        imgIdArray: null,
        categoryId: null,
        categoryIds: [],
        status:0,
        shopId: null,
        color: '#FFFFFF',
        refundTypeList: [1, 2],
        refundTime: 0,
        shopCategoryId: null,
        brandId: null,
        price: 0,
        marketPrice: 0,
        costPrice: 0,
        virtualSalesNum: 0,
        activityPrice: 0,
        seckillPrice: 0,
        memberPrice: 0,
        groupPrice: 0,
        freightTemplateId: null,
        stock: 0,
        alarmStock: null,
        description: null,
        isRecommend: false,
        isNew: false,
        isOrderLock: false,
        isHavePoster:false,
        isShowCalendar: false,
        isShowSalesNum: false,
        isShowStock: false,
        isShowApp: true,
        isRequireRemark: false,
        sort: null,
        realSales: null,
        parameter: null,
        prodArea: null,
        remark: null,
        localeFieldMap: {},

      };

    },


    limitMarketPrice() {
      // console.log(i);
      let val = this.form.marketPrice
      /*let skuList = [];
      //sku里的价格同步更新
      this.form.skuList.forEach(e => {
        e.price = val
        e.memberPrice = val
        e.groupPrice = val
        e.seckillPrice = val
        e.activityPrice = val
        e.archiveSpecList=[]
        skuList.push(e)
      });
      this.form.skuList = skuList*/
    },
    maxBuyChange() {
      if (!this.form.isMaxBuy) {
        this.form.maxBuyNum = 0;
      }
    },
    maxBuyNumChange() {
      this.form.skuList.forEach(e=>e.maxBuyNum = this.form.maxBuyNum)
    },
    validatorSku() {
      if (!this.form.skuList) {
        return true;
      }
      let message = "";
      this.form.skuList.forEach(e=>{
        let skuErrorMessage = "";
        if (e.price<=0) {
          skuErrorMessage +=this.$t('价格') + this.$t('不能小于0')+"; ";
        }
        if (e.seckillPrice<=0) {
          skuErrorMessage +=this.$t('秒杀价格') + this.$t('不能小于0')+"; ";
        }
        if (e.stock<0) {
          skuErrorMessage +=this.$t('库存') + this.$t('不能小于0')+"; ";
        }
        if (e.weight<0) {
          skuErrorMessage +=this.$t('重量') + this.$t('不能小于0')+"; ";
        }
        message=skuErrorMessage
      })
      if (message) {
        this.skuErrorMessage = message;
        return false;
      }
      this.skuErrorMessage = '';
      return true;
    },

    validatorSpecValue(item) {
      let specErrorMessage = "";
      item.specValueList.forEach(e=>{
        if (!e.specValueName) {
          specErrorMessage += this.$t('规格值') + this.$t('不能为空');
        }
      })
      if (specErrorMessage) {
        item.specErrorMessage = specErrorMessage;
        return false;
      }
      item.specErrorMessage= undefined;
      return true;
    },
    validatorSpecValueAll() {
      let result = true;
      this.form.specList.forEach(spec=>{
        let specErrorMessage = "";
        spec.specValueList.forEach(e=>{
          if (!e.specValueName) {
            specErrorMessage += this.$t('规格值') + this.$t('不能为空');
          }
        })
        if (specErrorMessage) {
          spec.specErrorMessage = specErrorMessage;
          result = false;
        } else {
          spec.specErrorMessage = undefined;
        }
      })

      return result;
    },

    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listCategory().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.categoryList = children
      })
    },

    /*页面初始化时获取标签类别*/
    getLabelList() {
      allLabel().then(response => {
        this.labelList = response.data;
      })
    },
    getFreightName() {
      if (this.form.freightTemplateId && this.form.freightTemplateDetail) {
        return this.form.freightTemplateDetail.name
      } else {
        return this.$t('请选择')+this.$t('运费模板')
      }
    },

    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    /*分类的选择（多选：value 直接为分类 id 数组）*/
    onCategoryChange(value) {
      const ids = (value && value.length) ? value : []
      this.form.categoryIds = ids
      this.form.categoryId = ids.length ? ids[0] : null
    },

    addSpec() {
      let validatorSpec = this.validatorSpecValueAll();
      if (!validatorSpec) {
        return;
      }
      const index = this.form.specList.length + 1;
      const newData = {
        id: index,
        specName: null,
        specDesc: null,
        isNew : true,
        isHaveImg: false,
        sort: index,
        specValueList: [],
      };
      this.form.specList.push(newData);
    },
    editSpec() {
      /*是否发生了规格变动如果有则保存到后台时会先执行删除商品操作 后执行添加商品操作  如果没有则 直接修改*/
      this.isChangeSpec=true;
      //修改规格后,清空所有sku
      this.form.skuList = [];
    },
    delSpec(id) {
      if (this.formType === 1) {
        this.form.specList.splice(id, 1)
        this.generateSkus();
        if (this.form.specList.length===0) {
          this.form.skuList = []
        }
      } else {
        /*let delSpecValueIdList = []
        this.form.specList.forEach(e => {
          if (e.id === id) {
            e.specValueIds.forEach(id=>{
              delSpecValueIdList.push(id);
            })
          }
        });
        //删除sku里的
        let sku = []
        this.form.skuList.forEach(e => {
          let valueIdList = e.specValueIds.split(":");
          //删除
          delSpecValueIdList.forEach(delSpecValueId => {
            let cateInfo = valueIdList.find(valueId => valueId === delSpecValueId);
            if (cateInfo) {

            } else {
              sku.push(e)
            }
          })
        });
        this.form.skuList = sku*/
      }
    },

    addSpecValue(item) {
      let validatorSpecValue = this.validatorSpecValueAll();
      if (!validatorSpecValue) {
        return;
      }
      //这个地方有个小bug,specValueList 用户可能会减一下,加一下,会造成index 重复,因此,取最后一个的id + 1
      let index = Number(item.id %100000 * 100) + item.specValueList.length + 1;
      //判断index在  item.specValueList 里是否重复, 如果重复,使用最后一个的id + 1
      let isRepeat = false;
      item.specValueList.forEach(e => {
        if (e.id === index.toString()) {
          isRepeat = true;
        }
      });
      if (isRepeat) {
        index = Number(item.specValueList[item.specValueList.length - 1].index) + 1;
        console.log('重新生成index',index)
      }
      const newData = {
        index: index.toString(),
        id: index.toString(),
        specValueName: null,
        specName: item.specName,
        picture: this.form.picture,
        isNew: true,
        specErrorMessage:undefined,
        sort: 0,
      };
      //新sku ,第一个不能删
      if (item.isNew && item.specValueList.length===0) {
        newData.notDelete = true;
      }
      item.specValueList.push(newData);
      //如果是新的规格添加新的规格值.需要修改sku
      if (item.isNew && item.specValueList.length===1) {
        let skuList = [];
        if (this.form.skuList.length===0) {
          this.generateSkus()
        } else {
          this.form.skuList.forEach(e => {
            e.specValueIds = e.specValueIds + ":"+index
            skuList.push(e)
          });
          this.form.skuList = skuList
        }
      } else {
        //如果是修改页面的增加规格值, 则在sku 里也新增1* 其他规格值的信息
        let specList = [];

        //拿到所有的sku值
        this.form.specList.forEach(spec => {
          if (spec.id === item.id) {
            let newDataList = []
            newDataList.push(newData)
            specList.push(newDataList);
          } else {
            specList.push(spec.specValueList);
          }
        });
        //递归,求笛卡尔积
        let sku = this.cartesianProduct(specList);
        //把这些sku 组装一下放到skuList里
        let index = 1;
        sku.forEach(e => {
          let name = '';
          let skuPic = '';
          let specValueIds = '';
          e.forEach(j => {
            name += j.specValueName + "  ";
            specValueIds += j.id + ":";
            if (j.picture) {
              skuPic = j.picture
            }
          });
          specValueIds = specValueIds.substring(0, specValueIds.length - 1);
          const newData = {
            id: index.toString(),
            skuName: name,
            skuCode: null,
            price: this.form.marketPrice,
            memberPrice: this.form.marketPrice,
            groupPrice: this.form.marketPrice,
            activityPrice: this.form.marketPrice,
            seckillPrice: this.form.marketPrice,
            freightTemplateId: this.form.freightTemplateId,
            freightTemplateName: this.form.freightTemplateDetail ? this.form.freightTemplateDetail.name : '',
            picture: null,
            isNew: true,
            specValueIds: specValueIds,
            stock: 99999,
            weight: 100,
          };
          this.form.skuList.push(newData);
          index++;
        });
      }
    },
    delSku(record) {
      const i = this.form.skuList.indexOf(record)
      if (i > -1) {
        this.form.skuList.splice(i, 1)
      }
    },
    delSpecValue(item, record) {
      console.log('删除',record)
      const specValue = item.specValueList.find(e => e.id === record.id);
      if (specValue) {
        specValue.isDeleted = true;
      }
      this.form.skuList.forEach(e => {
        let valueIdList = e.specValueIds.split(":");
        if (valueIdList.includes(record.id)) {
          e.isDeleted = true;
        }
      });
    },

    specValueChange: function (record) {
      let skuValueList = [];
      //拿到所有的sku值
      this.form.specList.forEach(spec => {
        spec.specValueList.forEach(specValue=>{
          skuValueList.push(specValue);
        })
      });
      //自动修改sku 里对应的规格名称
      //sku 里原本就有数据,修改sku 名字
      this.form.skuList.forEach(e => {
        let valueIdList = e.specValueIds.split(":");
        let name = ""
        valueIdList.forEach(specValueId => {
          if (record.id === specValueId) {
            name = name + record.specValueName + "  ";
          } else {
            const specValue =skuValueList.find(item => item.id === specValueId);
            if (specValue) {
              name = name + specValue.specValueName + "  "
            }
          }
        });
        e.skuName = name
      });
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.formTitle = this.$t('添加')
      // 新增商品默认带出默认运费模板（意见：默认规则应用到所有商品）
      this.prefillDefaultFreightTemplate()
    },
    // 预填默认运费模板（仅新增商品）
    prefillDefaultFreightTemplate() {
      shippingTemplatesList({ pageNum: 1, pageSize: 999 }).then(res => {
        const records = (res.data && res.data.records) ? res.data.records : (res.data || [])
        const def = records.find(r => r.isDefault)
        if (def) {
          this.form.freightTemplateId = def.id
          this.form.freightTemplateDetail = { id: def.id, name: def.name, type: def.type }
        }
      }).catch(() => {})
    },
    /** 修改按钮操作 */
    handleUpdate(id, copy) {
      this.reset()
      this.formType = 2
      getGoods({"id": id}).then(response => {
        this.form = response.data
        // 回显出分类（多选：categorySelected 直接为分类 id 数组）
        const cids = this.form.categoryIds || (this.form.categoryId != null ? [this.form.categoryId] : [])
        this.categorySelected = cids
        if (copy) {
          this.formTitle = this.$t('复制');
          this.formType = 1
          this.form.id = null
          this.form.goodsName = this.form.goodsName+"(复制)"
          this.form.status=0
          /*this.form.goodsArchiveId=null
          this.form.goodsBatchId=null*/
          this.form.imgList = [];
          this.form.onSaleTime = null
          let oldSkuList = this.form.skuList
          this.generateSkus()
          //按照名称进行匹配,将oldSkuList里的价格赋值到form.skuList里去
          oldSkuList.forEach(e => {
            this.form.skuList.forEach(sku => {
              //skuName trim 匹配
              if (sku.skuName.trim() === e.skuName.trim()) {
                sku.price = e.price
                sku.maxBuyNum = e.maxBuyNum
                sku.freightTemplateId = e.freightTemplateId
                sku.freightTemplateName = e.freightTemplateName
                sku.memberPrice = e.price
                sku.stock = e.stock
                sku.groupPrice = e.price
                sku.activityPrice = e.price
                sku.seckillPrice = e.price
              }
            });
          });
          this.form.skuList.forEach(e=>{
            e.isNew = true
          })
          this.form.specList.forEach(e => {
            e.isNew =true
            e.specValueList.forEach(value => {
              value.isNew =true
            })
          });
        } else {
          this.formTitle = this.$t('修改');
        }
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    pictureChange() {
      let picture = this.form.picture;
      if (this.form.skuList) {
        this.form.skuList.forEach(e => {
          if (!e.picture) {
            e.picture=picture;
          }
        });
      }
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        let skuValid = this.validatorSku();
        if (!skuValid) {
          return false;
        }
        if (valid) {
          this.submitLoading = true;
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.isChangeSpec = this.isChangeSpec;
            updateGoods(this.form).then(response => {
              this.$message.success(
                this.$t('修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
              this.back();
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGoods(this.form).then(response => {
              this.$message.success(
                this.$t('新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
              this.back();
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>
<style lang="less" >
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}
.box {
  position: relative;
  background-color: #f7f7f7;
  padding: 0 15px 15px 15px;
  margin-bottom: 15px;
  border-radius: 5px;

  .delSpec {
    position: absolute;
    right: -5px;
    top: -5px;
    color: #f5222d;
    cursor: pointer;
  }
}
.ant-input-suffix {
  position: absolute;
  top: 50%;
  z-index: 2;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
  line-height: 0;
  transform: translateY(-50%);
  right: 12px;
}
.ant-input-suffix-button {
  position: absolute;
  right: -11px;
}

</style>
